<template>
  <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      :width="width"
      :height="height"
      :fill="color"
  >
    <path
        fill="currentColor"
        d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 336H48V112h416v288zm-88-128c0-13.255-10.745-24-24-24s-24 10.745-24 24 10.745 24 24 24 24-10.745 24-24zm-80 0c0-13.255-10.745-24-24-24s-24 10.745-24 24 10.745 24 24 24 24-10.745 24-24zm-80 0c0-13.255-10.745-24-24-24s-24 10.745-24 24 10.745 24 24 24 24-10.745 24-24zm-80 0c0-13.255-10.745-24-24-24s-24 10.745-24 24 10.745 24 24 24 24-10.745 24-24zM160 208c0-13.255-10.745-24-24-24s-24 10.745-24 24 10.745 24 24 24 24-10.745 24-24zm184 0c0-13.255-10.745-24-24-24s-24 10.745-24 24 10.745 24 24 24 24-10.745 24-24z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: "30",
    },
    height: {
      type: String,
      default: "30",
    },
    color: {
      type: String,
      default: "#fff",
    },
  },
};
</script>

<style lang="scss" scoped>
svg {
  text-align: center;
  vertical-align: middle;
}
</style>